module.exports = __webpack_public_path__ + "img/DS620slim.21c25738.png";